import { SKIP, visit } from 'unist-util-visit';

import AdContainerIds from '@/components/ads/ad-container-ids';
import { AdSlotAttr } from '@/components/ads/hooks/use-ad-slot';

import createNode from '../utils/create-node';

const rehypeAdPlacement = ({ adAttributes }: { adAttributes: AdSlotAttr }) => {
    return (tree: any) => {
        const paragraphCount = tree.children.filter((e: { tagName: string }) => e.tagName === 'p').length;
        const injectionIndex = Math.floor(paragraphCount / 2);
        let i = 0;

        visit(tree, 'element', (node, index) => {
            if (node.tagName === 'p') {
                if (i++ === injectionIndex) {
                    tree.children.splice(
                        index,
                        0,
                        createNode({
                            id: AdContainerIds.NewsArticleMidArticle300x250.id,
                            nodeClassName: 'article-ad ad-slot ad-slot-label mt-8 mb-4 lg:hidden',
                            tagName: 'div',
                            attributes: {
                                'data-ad-slot': adAttributes['data-ad-slot'],
                                'data-ad-client': adAttributes['data-ad-client'],
                            } as React.HTMLProps<'div'>,
                        }),
                    );

                    return [SKIP];
                }
            }
            return [];
        });
    };
};

export default rehypeAdPlacement;
